// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3NeCb","colMaxWidth":"Table_colMaxWidth__3fvJB"};